<template>
    <h3 class="tw:mb-2 tw:text-lg tw:font-semibold tw:leading-tight">{{ title }}</h3>
</template>

<script setup>
	defineProps({
		title: { type: String, required: true },
	})
</script>